import React from "react";

import {
  FaPlus,
  FaSyncAlt,
} from "react-icons/fa";

import {
  BarChart3,
} from "lucide-react";

export default function SubscriptionsHeader({
  onRefresh,
  onAdd,
  isRefreshing = false,
}) {
  return (
    <header className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-slate-950 via-indigo-950 to-violet-900 px-5 py-7 text-white shadow-xl sm:px-7 lg:px-9">
      <div className="absolute -right-20 -top-20 h-64 w-64 rounded-full bg-fuchsia-500/20 blur-3xl" />

      <div className="absolute -bottom-24 left-1/3 h-64 w-64 rounded-full bg-sky-500/20 blur-3xl" />

      <div className="relative flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-start gap-4">
          <div className="hidden h-14 w-14 shrink-0 place-items-center rounded-2xl bg-white/10 text-2xl ring-1 ring-white/15 backdrop-blur sm:grid">
            <BarChart3
              size={25}
            />
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-indigo-200">
              Pilotage commercial
            </p>

            <h1 className="mt-2 text-2xl font-black tracking-tight sm:text-3xl">
              Abonnements & revenus
            </h1>

            <p className="mt-2 max-w-2xl text-sm leading-6 text-indigo-100/80">
              Anticipe les
              renouvellements,
              sécurise les revenus et
              concentre-toi sur les
              dossiers qui nécessitent
              réellement une action.
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-3 sm:flex-row">
          <button
            type="button"
            onClick={() =>
              onRefresh?.()
            }
            disabled={
              isRefreshing
            }
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-white/10 px-4 py-3 text-sm font-bold text-white ring-1 ring-white/15 transition hover:bg-white/20 disabled:cursor-wait disabled:opacity-60"
          >
            <FaSyncAlt
              className={
                isRefreshing
                  ? "animate-spin"
                  : ""
              }
            />

            Actualiser
          </button>

          <button
            type="button"
            onClick={() =>
              onAdd?.()
            }
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-white px-5 py-3 text-sm font-black text-indigo-700 shadow-lg transition hover:-translate-y-0.5 hover:bg-indigo-50"
          >
            <FaPlus />

            Ajouter une vente
          </button>
        </div>
      </div>
    </header>
  );
}